<template lang="html">
  <div class="" id="pag-reservation-bedroom">
    <div class="container">

      <div class="row">
        <h2 class="title">{{$t('telas.reserva_quartos.titulo')}}</h2>
      </div>

      <reserva
        v-bind:header="false"
        :obs="['Selecione aqui a data da sua reserva']">
      </reserva>

    </div>
  </div>
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'

export default {
  name: 'SelectDatesReservation',

  components: {
    reserva
  },

  methods: {
    router(route){
      this.$router.push({name: route})
    }
  }

}
</script>

<style lang="css">
@import url('https://fonts.googleapis.com/css?family=Quicksand');

#pag-reservation-bedroom {
  background-color: white;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}
#pag-reservation-bedroom div.container div.row h2.title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  font-weight: bold;
}

#pag-reservation-bedroom div.container div.row-item {
  background-color: rgb(23, 162, 184);
  color: white;
  border-radius: 5px;
  padding: 10px;
  margin: 0;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/reservation/SelectDates.vue